import { useWorkspaceTreatments } from '@/features/splits';
import { useRef } from 'react';

/**
 * Check for automations Split feature flag
 * @returns true if enabled, false otherwise
 */
export const useAutomationsFeatureFlag = () => {
  const isEnabled = useRef<boolean>(false);
  const { treatments } = useWorkspaceTreatments(['fe_admin_app_automations']);
  const automationsTreatment = treatments.fe_admin_app_automations.treatment;

  // ignore 'control' not to cause feature turning off while loading, just check final states
  if (automationsTreatment === 'on') {
    isEnabled.current = true;
  } else if (automationsTreatment === 'off') {
    isEnabled.current = false;
  }

  return isEnabled.current;
};
